const moment = require('moment');

/** 请求类型对应的标签颜色 */
const METHOD_TAG_TYPE = {
  GET: 'success',
  POST: '',
  PUT: 'warning',
  PATCH: 'warning',
  DELETE: 'danger',
  HEAD: 'info',
  OPTIONS: 'info',
};

/**
 * 响应状态码对应的标签颜色
 * @param {number} status_code 响应状态码
 * @returns {string}
 */
function getStatusCodeTagType(status_code) {
  if (status_code >= 200 && status_code < 300) {
    return 'success';
  }
  if (status_code >= 300 && status_code < 400) {
    return 'info';
  }
  if (status_code >= 400 && status_code < 500) {
    return 'warning';
  }
  return 'danger';
}

/**
 * 格式化查询次数
 * @param {number} count 查询次数
 * @returns {string}
 */
function formatCount(count) {
  return count || count === 0 ? String(count) : '-';
}

/**
 * 格式化耗时（毫秒）
 * @param {number} duration 耗时
 * @returns {string}
 */
function formatDuration(duration) {
  return duration || duration === 0 ? `${duration} ms` : '-';
}

module.exports = (s) => {
  return [
    {
      name: '日志ID',
      value: 'id',
      width: 60,
    },
    {
      name: '请求类型',
      value: 'method',
      width: 80,
      align: 'center',
      format: (row) => {
        const tag_type = row.method in METHOD_TAG_TYPE ? METHOD_TAG_TYPE[row.method] : 'info';
        return s.$createElement('el-tag', {
          props: {
            size: 'mini',
            type: tag_type,
          },
        }, row.method || '-');
      },
    },
    {
      name: '请求地址',
      value: 'path',
      props: {
        'min-width': 220,
      },
      format: row => row.path || '-',
    },
    {
      name: '路由名称',
      value: 'route_name',
      props: {
        'min-width': 180,
      },
      format: row => row.route_name || '-',
    },
    {
      name: '请求账号',
      value: 'username',
      width: 120,
      format: row => row.username || '-',
    },
    {
      name: '请求IP',
      value: 'ip',
      width: 140,
      format: row => row.ip || '-',
    },
    {
      name: '响应状态码',
      value: 'status_code',
      width: 100,
      align: 'center',
      format: (row) => {
        if (!row.status_code) {
          return '-';
        }
        return s.$createElement('el-tag', {
          props: {
            size: 'mini',
            type: getStatusCodeTagType(row.status_code),
          },
        }, String(row.status_code));
      },
    },
    {
      name: '请求耗时',
      value: 'duration',
      width: 100,
      align: 'center',
      format: row => formatDuration(row.duration),
    },
    {
      name: '数据库查询',
      align: 'center',
      children: [
        {
          name: '次数',
          value: 'db_query_count',
          width: 80,
          align: 'center',
          format: row => formatCount(row.db_query_count),
        },
        {
          name: '总耗时',
          value: 'db_query_time',
          width: 90,
          align: 'center',
          format: row => formatDuration(row.db_query_time),
        },
        {
          name: '最大耗时',
          value: 'db_query_max_time',
          width: 90,
          align: 'center',
          format: row => formatDuration(row.db_query_max_time),
        },
      ],
    },
    {
      name: 'Redis查询',
      align: 'center',
      children: [
        {
          name: '次数',
          value: 'redis_query_count',
          width: 80,
          align: 'center',
          format: row => formatCount(row.redis_query_count),
        },
        {
          name: '总耗时',
          value: 'redis_query_time',
          width: 90,
          align: 'center',
          format: row => formatDuration(row.redis_query_time),
        },
        {
          name: '最大耗时',
          value: 'redis_query_max_time',
          width: 90,
          align: 'center',
          format: row => formatDuration(row.redis_query_max_time),
        },
      ],
    },
    {
      name: '请求参数',
      value: 'params',
      props: {
        'min-width': 200,
      },
      // 关闭超出省略，改为单元格内滚动展示
      overflow: false,
      format: (row) => {
        return s.$createElement('div', {
          style: {
            maxHeight: '120px',
            overflow: 'auto',
            textAlign: 'left',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-all',
            lineHeight: '18px',
          },
        }, s.formatParams(row.params));
      },
    },
    {
      name: '请求UA',
      value: 'user_agent',
      props: {
        'min-width': 150,
      },
      format: row => row.user_agent || '-',
    },
    {
      name: '请求时间',
      value: 'request_time',
      width: 150,
      format: row => (row.request_time ? moment(row.request_time).format('YYYY-MM-DD HH:mm:ss') : '-'),
    },
    {
      name: '入库时间',
      value: 'created_at',
      width: 150,
      format: row => (row.created_at ? moment(row.created_at).format('YYYY-MM-DD HH:mm:ss') : '-'),
    },
  ];
};
